<template lang="html">
  <transition
    enter-active-class="animated zoomCustomIn"
    leave-active-class="animated zoomCustomOut"
    mode="out-in"
  >
    <button
      v-show="visible"
      v-scroll-to="'body'"
      class="scrollTo"
      :class="[
        {
          'scrollTo--negative': $route.name === 'AboutUs' || $route.name === 'works',
          'scrollTo--fixed': isFixed,
        },
      ]"
    ></button>
  </transition>
</template>

<script lang="js">
  export default  {
    name: 'scrollTo',
    data () {
      return {
        visible: false,
        isFixed: false,
      }
    },

    watch: {
      $route() {
        this.visible = false;
        this.setTrigger();
      }
    },

    mounted() {
      this.setTrigger();
    },

    methods: {
      setTrigger() {
        // eslint-disable-next-line no-unused-vars
        let positionBlocked = 0;

        $(document).on("scroll", () => {
          const windowPosition = $('body, html').scrollTop();
          const buttonOnFooter = $('.scrollTo').position().top >= ($('main').height() - windowPosition);
          const buttonNotFooter = positionBlocked > 0 && windowPosition < positionBlocked;

          if (windowPosition > 100 && !this.visible) {
            this.visible = true;
          }

          if (windowPosition <= 30 && this.visible) {
            this.visible = false;
          }

          if(buttonOnFooter && !this.isFixed){
            this.isFixed = true;
            this.$hub.$emit('animateFooter');
            positionBlocked = windowPosition
          }

          if (buttonNotFooter && this.isFixed) {
            this.isFixed = false;
          }
        });
      }
    },
}
</script>

<style scoped lang="scss">
.scrollTo {
  position: fixed;
  right: 20px;
  bottom: 30px;
  z-index: 5;
  transition: all 0.3s ease-in-out;
  transform: scale(1);
  cursor: pointer;

  background: url("../../assets/white.png") no-repeat center center;
  background-color: transparent;
  padding: 30px;
  background-size: 100%;
  border: 0;
  outline: none;

  &:hover {
    transform: scale(1.1);
    transition: all 0.3s ease-in-out;
  }

  &--negative {
    background: url("../../assets/black.png") no-repeat center center;
    background-size: 100%;
  }

  &--fixed {
    position: absolute;
  }

  @media (max-width: 1000px) {
    padding: 23px;
  }
}
</style>
